"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = void 0;
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["LoadFailed"] = "load-failed";
    ErrorCode["PersistenceFailed"] = "persistence-failed";
    ErrorCode["TooBig"] = "too-big";
    ErrorCode["CorruptData"] = "corrupt-data";
    ErrorCode["LessonNotFound"] = "lesson-not-found";
})(ErrorCode || (exports.ErrorCode = ErrorCode = {}));
//# sourceMappingURL=error-code.js.map